import React from 'react';

const Step4_Complete = ({ rowCount, urlCount, onRestart }) => (
  <div className="space-y-8">
    <div className="text-center">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Complete</h2>
      <p className="text-gray-600">Extraction finished. You can export again from the previous step or start a new run.</p>
    </div>
    <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
      <p className="font-semibold text-green-800">
        {rowCount} row{rowCount !== 1 ? 's' : ''} from {urlCount} URL{urlCount !== 1 ? 's' : ''}
      </p>
    </div>
    <div className="flex justify-center">
      <button
        type="button"
        onClick={onRestart}
        className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium"
      >
        Start new extraction
      </button>
    </div>
  </div>
);

export default Step4_Complete;
